// extracted by mini-css-extract-plugin
module.exports = {"overlay":"BottomSheet_overlay__BQ7eS","container":"BottomSheet_container__y3K20","content":"BottomSheet_content__66jjN"};